import { ComponentPropsWithoutRef } from 'react';
import { twMerge } from 'tailwind-merge';
import { Image } from '../../shared/Image';
import { ItineraryCard, ItineraryCardProps } from '../ItineraryCard';
export type ItineraryDialogContentProps = {
  imageLandscape?: ComponentPropsWithoutRef<typeof Image>;
  imageSquare?: ComponentPropsWithoutRef<typeof Image>;
  cards?: ItineraryCardProps[];
};
const ItineraryDialogContent = (props: ItineraryDialogContentProps) => {
  const {
    imageLandscape,
    imageSquare,
    cards
  } = props;
  return <div className="flex w-full flex-col bg-gray lg:flex-row-reverse lg:gap-4 lg:p-11" data-sentry-component="ItineraryDialogContent" data-sentry-source-file="ItineraryDialogContent.tsx">
      {imageLandscape && <Image {...imageLandscape} className={twMerge(imageLandscape.className, 'aspect-16/9 w-full lg:aspect-1/1 lg:flex-1', imageSquare && 'lg:hidden')} />}
      {imageSquare && <Image {...imageSquare} className={twMerge(imageSquare.className, 'aspect-16/9 w-full lg:aspect-1/1 lg:flex-1', imageLandscape && 'hidden lg:block')} />}
      <div className="flex w-full flex-col gap-1 p-4 pb-8 scrollbar-hidden lg:aspect-1/1 lg:flex-1 lg:overflow-y-auto lg:p-0">
        {cards && cards.map((card, index) => <ItineraryCard key={index} {...card} />)}
      </div>
    </div>;
};
ItineraryDialogContent.displayName = 'ItineraryDialogContent';
export { ItineraryDialogContent };